import addOA from './addOA';
import batchDeduct from './batchDeduct';
import cart from './cart';
import collectPoint from './collectPoint';
import components from './components';
import countryCode from './countryCode';
import coupon from './coupon';
import couponErrorCode from './couponErrorCode';
import error from './ErrorPage';
import enumerate from './enumerate';
import home from './home';
import invoiceCarrier from './invoiceCarrier';
import me from './me';
import memberArea from './memberArea';
import memberAreaCouponHistory from './memberAreaCouponHistory';
import memberAreaJourney from './memberAreaJourney';
import memberAreaPointsHistory from './memberAreaPointsHistory';
import system from './memberAreaSystem';
import memberBenefit from './memberBenefit';
import memberCard from './memberCard';
import memberPoint from './memberPoint';
import memberReferral from './memberReferral';
import memberSuspension from './memberSuspension';
import modifyProfile from './modifyProfile';
import onlineStore from './onlineStore';
import paymentHistory from './paymentHistory';
import pointCard from './pointCard';
import pointsHistory from './pointsHistory';
import privacy from './privacy';
import product from './product';
import redeemCoupon from './redeemCoupon';
import redeemPoint from './redeemPoint';
import register from './register';
import registerBenefit from './registerBenefit';
import returnInstruction from './returnInstruction';
import searchProduct from './searchProduct';
import serialRedemption from './serialRedemption';
import shareCoupon from './shareCoupon';
import shoppingNote from './shoppingNote';
import storeOrders from './storeOrders';
import storeValueCard from './storeValueCard';
import survey from './survey';
import terms from './terms';
import transactions from './transactions';

export default {
  a_kit_remaining: '請出示本頁面讓工作人員蓋章',
  a_kit_unavailable: '核銷服務暫時無法使用，請稍後再試。',
  redeem: '核銷',
  code: '代碼',
  barcode: '條碼',
  ...enumerate,
  ...countryCode,
  ...addOA,
  ...batchDeduct,
  ...cart,
  ...collectPoint,
  ...components,
  ...coupon,
  ...couponErrorCode,
  ...home,
  ...invoiceCarrier,
  ...me,
  ...memberArea,
  ...memberAreaCouponHistory,
  ...memberAreaJourney,
  ...memberAreaPointsHistory,
  ...memberBenefit,
  ...memberCard,
  ...memberPoint,
  ...modifyProfile,
  ...onlineStore,
  ...paymentHistory,
  ...pointCard,
  ...pointsHistory,
  ...privacy,
  ...product,
  ...redeemCoupon,
  ...redeemPoint,
  ...register,
  ...registerBenefit,
  ...returnInstruction,
  ...searchProduct,
  ...shareCoupon,
  ...shoppingNote,
  ...serialRedemption,
  ...storeOrders,
  ...storeValueCard,
  ...survey,
  ...terms,
  ...transactions,
  ...system,
  ...error,
  ...memberReferral,
  ...memberSuspension,
} as Record<string, string>;
